import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_2 = { class: "bg-white px-4 py-4 sm:p-6" }
const _hoisted_3 = { class: "flex items-center justify-between gap-2" }
const _hoisted_4 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_5 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_6 = { class: "py-4" }
const _hoisted_7 = { class: "relative bg-white shadow-sm rounded-lg flex flex-col p-3" }
const _hoisted_8 = { class: "flex items-start justify-between" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "grid grid-cols-6 gap-2" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_13 = { class: "col-span-6 flex gap-2" }
const _hoisted_14 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex items-center gap-4 w-full" }
const _hoisted_19 = {
  key: 0,
  class: "shrink-0 size-16",
  width: "71",
  height: "51",
  viewBox: "0 0 71 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "grow" }
const _hoisted_22 = { class: "inline-flex flex-wrap gap-1 text-sm/6 text-gray-600" }
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = { class: "bg-white text-royal-blue-700 hover:text-royal-blue-800 rounded-lg decoration-2 hover:underline focus-within:outline-hidden focus-within:ring-2 focus-within:ring-royal-blue-800 focus-within:ring-offset-2" }
const _hoisted_25 = { class: "text-xs text-gray-400" }
const _hoisted_26 = { class: "flex items-center gap-2 justify-end" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_29 = { class: "p-3 bg-white border border-solid border-gray-300 rounded-lg" }
const _hoisted_30 = { class: "mb-1 flex justify-between items-center" }
const _hoisted_31 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_32 = { class: "text-sm text-gray-800" }
const _hoisted_33 = { class: "flex items-center gap-x-3 whitespace-nowrap" }
const _hoisted_34 = {
  class: "flex w-full h-2 bg-gray-200 rounded-full overflow-hidden",
  role: "progressbar",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_35 = ["onChange"]
const _hoisted_36 = { class: "col-span-6" }
const _hoisted_37 = { class: "block mb-2 font-medium text-sm text-gray-800" }
const _hoisted_38 = { class: "pt-3 mt-auto flex items-center gap-2 justify-end" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "p-5 min-h-96 flex flex-col justify-center items-center text-center"
}
const _hoisted_42 = { class: "max-w-sm mx-auto" }
const _hoisted_43 = { class: "mt-2 font-medium text-gray-800" }
const _hoisted_44 = { class: "mb-5 text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_UserDescriptionEditor = _resolveComponent("UserDescriptionEditor")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.pricesBlockTitle), 1),
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-1 rounded-md border border-royal-blue-600 text-royal-blue-600 px-2 py-1.5 text-xs hover:bg-royal-blue-600 cursor-pointer hover:text-white",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.beginAdd && _ctx.beginAdd(...args)))
          }, [
            _createVNode(_component_PlusIcon, { class: "size-4" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('profile.prices_add_button')), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('profile.prices_tip')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.localItems,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localItems) = $event)),
        "item-key": "id",
        group: { name: 'profile-prices', pull: true, put: true },
        onEnd: _ctx.onDragEnd,
        tag: "ul",
        class: "grid grid-cols-1 sm:grid-cols-2 gap-4",
        handle: ".handle"
      }, {
        item: _withCtx(({ element }) => [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((element.title) = $event),
                      type: "text",
                      placeholder: _ctx.$t('profile.prices_title_placeholder'),
                      class: "block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, element.title]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((element.price) = $event),
                      type: "number",
                      step: "0.01",
                      min: "0",
                      placeholder: _ctx.$t('profile.prices_price'),
                      class: "block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600"
                    }, null, 8, _hoisted_14), [
                      [
                        _vModelText,
                        element.price,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((element.currency) = $event),
                      class: "rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600"
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("option", { value: "USD" }, "$", -1),
                      _createElementVNode("option", { value: "EUR" }, "€", -1),
                      _createElementVNode("option", { value: "UAH" }, "₴", -1),
                      _createElementVNode("option", { value: "PLN" }, "zł", -1)
                    ]), 8, _hoisted_15), [
                      [_vModelSelect, element.currency]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: "cursor-pointer p-4 flex bg-white border border-gray-200 rounded-lg",
                        onClick: ($event: any) => (_ctx.triggerFile(element.id))
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          (!element.cover_url)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[3] || (_cache[3] = [
                                _createElementVNode("path", {
                                  d: "M6.55172 8.74547L17.7131 6.88524V40.7377L12.8018 41.7717C9.51306 42.464 6.29705 40.3203 5.67081 37.0184L1.64319 15.7818C1.01599 12.4748 3.23148 9.29884 6.55172 8.74547Z",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  class: "stroke-gray-700"
                                }, null, -1),
                                _createElementVNode("path", {
                                  d: "M64.4483 8.74547L53.2869 6.88524V40.7377L58.1982 41.7717C61.4869 42.464 64.703 40.3203 65.3292 37.0184L69.3568 15.7818C69.984 12.4748 67.7685 9.29884 64.4483 8.74547Z",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  class: "stroke-gray-700"
                                }, null, -1),
                                _createElementVNode("g", { filter: "url(#filter1)" }, [
                                  _createElementVNode("rect", {
                                    x: "17.5656",
                                    y: "1",
                                    width: "35.8689",
                                    height: "42.7541",
                                    rx: "5",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    class: "stroke-gray-700",
                                    "shape-rendering": "crispEdges"
                                  })
                                ], -1),
                                _createElementVNode("path", {
                                  d: "M39.4826 33.0893C40.2331 33.9529 41.5385 34.0028 42.3537 33.2426L42.5099 33.0796L47.7453 26.976L53.4347 33.0981V38.7544C53.4346 41.5156 51.1959 43.7542 48.4347 43.7544H22.5656C19.8043 43.7544 17.5657 41.5157 17.5656 38.7544V35.2934L29.9728 22.145L39.4826 33.0893Z",
                                  fill: "currentColor",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  class: "fill-gray-100 stroke-gray-700"
                                }, null, -1),
                                _createElementVNode("circle", {
                                  cx: "40.0902",
                                  cy: "14.3443",
                                  r: "4.16393",
                                  fill: "currentColor",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  class: "fill-gray-100 stroke-gray-700"
                                }, null, -1),
                                _createElementVNode("defs", null, [
                                  _createElementVNode("filter", {
                                    id: "filter1",
                                    x: "13.5656",
                                    y: "0",
                                    width: "43.8689",
                                    height: "50.7541",
                                    filterUnits: "userSpaceOnUse",
                                    "color-interpolation-filters": "sRGB"
                                  }, [
                                    _createElementVNode("feFlood", {
                                      "flood-opacity": "0",
                                      result: "BackgroundImageFix"
                                    }),
                                    _createElementVNode("feColorMatrix", {
                                      in: "SourceAlpha",
                                      type: "matrix",
                                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                      result: "hardAlpha"
                                    }),
                                    _createElementVNode("feOffset", { dy: "3" }),
                                    _createElementVNode("feGaussianBlur", { stdDeviation: "1.5" }),
                                    _createElementVNode("feComposite", {
                                      in2: "hardAlpha",
                                      operator: "out"
                                    }),
                                    _createElementVNode("feColorMatrix", {
                                      type: "matrix",
                                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                                    }),
                                    _createElementVNode("feBlend", {
                                      mode: "normal",
                                      in2: "BackgroundImageFix",
                                      result: "effect1"
                                    }),
                                    _createElementVNode("feBlend", {
                                      mode: "normal",
                                      in: "SourceGraphic",
                                      in2: "effect1",
                                      result: "shape"
                                    })
                                  ])
                                ], -1)
                              ])))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: element.cover_url,
                                alt: "",
                                class: "shrink-0 size-16 rounded-md object-cover"
                              }, null, 8, _hoisted_20)),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('profile.prices_cover_drop_or')), 1),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('profile.prices_cover_browse')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('profile.prices_cover_size')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            (element.cover_url)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "text-gray-500 hover:text-red-600",
                                  onClick: _withModifiers(($event: any) => (_ctx.deleteCover(element)), ["stop"])
                                }, _cache[4] || (_cache[4] = [
                                  _createElementVNode("svg", {
                                    class: "shrink-0 size-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M3 6h18" }),
                                    _createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
                                    _createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
                                    _createElementVNode("line", {
                                      x1: "10",
                                      x2: "10",
                                      y1: "11",
                                      y2: "17"
                                    }),
                                    _createElementVNode("line", {
                                      x1: "14",
                                      x2: "14",
                                      y1: "11",
                                      y2: "17"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 8, _hoisted_17),
                      (_ctx.uploadProgress[element.id] != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('profile.prices_cover_label')), 1),
                                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.uploadProgress[element.id]) + "%", 1)
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", {
                                    class: "flex flex-col justify-center rounded-full overflow-hidden bg-royal-blue-700 text-xs text-white text-center whitespace-nowrap transition-all duration-500",
                                    style: _normalizeStyle({ width: _ctx.uploadProgress[element.id] + '%' })
                                  }, null, 4)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        ref: `fileInput_${element.id}`,
                        type: "file",
                        class: "hidden",
                        accept: "image/*",
                        onChange: ($event: any) => (String(element.id).startsWith('tmp-') ? _ctx.onCoverSelectedTemp($event, element) : _ctx.onCoverSelected($event, element))
                      }, null, 40, _hoisted_35)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('profile.description')), 1),
                    _createVNode(_component_UserDescriptionEditor, {
                      modelValue: element.description,
                      "onUpdate:modelValue": ($event: any) => ((element.description) = $event),
                      placeholder: _ctx.$t('profile.prices_description_placeholder')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center gap-2 mr-auto" }, [
                _createElementVNode("div", { class: "cursor-move text-gray-400 hover:text-gray-600 p-1 handle" }, [
                  _createElementVNode("svg", {
                    class: "size-5",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "6",
                      r: "1"
                    }),
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "12",
                      r: "1"
                    }),
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "18",
                      r: "1"
                    }),
                    _createElementVNode("circle", {
                      cx: "16",
                      cy: "6",
                      r: "1"
                    }),
                    _createElementVNode("circle", {
                      cx: "16",
                      cy: "12",
                      r: "1"
                    }),
                    _createElementVNode("circle", {
                      cx: "16",
                      cy: "18",
                      r: "1"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("button", {
                class: "text-white bg-red-600 px-4 py-2 rounded-md hover:bg-red-700 cursor-pointer",
                onClick: ($event: any) => (_ctx.remove(element))
              }, [
                _createVNode(_component_TrashIcon, { class: "size-4" })
              ], 8, _hoisted_39),
              _createElementVNode("button", {
                class: "inline-flex justify-center rounded-md bg-blue-700 px-4 py-2 text-xs font-semibold text-white shadow-xs hover:bg-blue-600 cursor-pointer",
                onClick: ($event: any) => (_ctx.save(element))
              }, _toDisplayString(_ctx.$t('profile.save')), 9, _hoisted_40)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onEnd"]),
      (_ctx.localItems.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _cache[6] || (_cache[6] = _createStaticVNode("<svg class=\"w-48 mx-auto mb-4\" width=\"178\" height=\"114\" viewBox=\"0 0 178 114\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"18\" y=\"12\" width=\"42\" height=\"96\" rx=\"8\" fill=\"currentColor\" class=\"fill-white\"></rect><rect x=\"18\" y=\"12\" width=\"42\" height=\"96\" rx=\"8\" stroke=\"currentColor\" class=\"stroke-gray-100\"></rect><rect x=\"26\" y=\"20\" width=\"26\" height=\"26\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"26\" y=\"50\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"26\" y=\"62\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"68\" y=\"6\" width=\"42\" height=\"108\" rx=\"8\" fill=\"currentColor\" class=\"fill-white\"></rect><rect x=\"68\" y=\"6\" width=\"42\" height=\"108\" rx=\"8\" stroke=\"currentColor\" class=\"stroke-gray-100\"></rect><rect x=\"76\" y=\"14\" width=\"26\" height=\"26\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"76\" y=\"44\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"76\" y=\"56\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"76\" y=\"68\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"118\" y=\"12\" width=\"42\" height=\"96\" rx=\"8\" fill=\"currentColor\" class=\"fill-white\"></rect><rect x=\"118\" y=\"12\" width=\"42\" height=\"96\" rx=\"8\" stroke=\"currentColor\" class=\"stroke-gray-100\"></rect><rect x=\"126\" y=\"20\" width=\"26\" height=\"26\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"126\" y=\"50\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"126\" y=\"62\" width=\"26\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect></svg>", 1)),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('profile.prices_empty')), 1),
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('profile.prices_empty_description')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}